module.exports = __webpack_public_path__ + "img/icon5.ec9465cb.svg";